import { useState, useEffect, useRef } from 'react';
import { supabase } from '../supabase';
import { C, fmt, audit } from '../constants';
import { Btn, Card, Toast, NivelBadge } from '../components/Atoms';

// ─── TOMBOLA (visual — turno ya pre-asignado) ─────────────
function Tombola({ turnoAsignado, totalSemanas: totalProp, onConfirmar }) {
  const [fase, setFase] = useState('idle');
  const [numMostrado, setNumMostrado] = useState('?');
  const [confetis, setConfetis] = useState([]);
  const intervalRef = useRef(null);
  const totalSemanas = totalProp || turnoAsignado || 10;

  const iniciarSorteo = () => {
    setFase('girando');
    setNumMostrado('?');
    let velocidad = 60;
    let iteraciones = 0;
    const totalIteraciones = 28;
    const girar = () => {
      setNumMostrado(Math.floor(Math.random() * totalSemanas) + 1);
      iteraciones++;
      if (iteraciones < totalIteraciones) {
        if (iteraciones > 20) velocidad = 120;
        if (iteraciones > 24) velocidad = 220;
        intervalRef.current = setTimeout(girar, velocidad);
      } else {
        // Mostrar el turno real pre-asignado
        setNumMostrado(turnoAsignado);
        setFase('resultado');
        const cs = Array.from({ length: 24 }, (_, i) => ({
          id: i, x: Math.random() * 100,
          color: ['#1A56DB','#0EA5E9','#059669','#F59E0B','#EF4444','#8B5CF6'][i % 6],
          delay: Math.random() * 0.5, size: 6 + Math.random() * 8,
        }));
        setConfetis(cs);
        setTimeout(() => setConfetis([]), 3500);
      }
    };
    intervalRef.current = setTimeout(girar, velocidad);
  };

  return (
    <div style={{ textAlign: 'center', padding: '8px 0', position: 'relative' }}>
      <style>{`
        @keyframes caer{0%{transform:translateY(-20px) rotate(0deg);opacity:1}100%{transform:translateY(300px) rotate(720deg);opacity:0}}
        @keyframes pulso{0%,100%{transform:scale(1)}50%{transform:scale(1.08)}}
        @keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}
      `}</style>
      {confetis.map(c => (
        <div key={c.id} style={{ position: 'absolute', left: `${c.x}%`, top: 0, width: c.size, height: c.size, background: c.color, borderRadius: 2, pointerEvents: 'none', animation: `caer 3s ${c.delay}s ease-in forwards`, zIndex: 10 }} />
      ))}
      {fase === 'idle' && (
        <div>
          <div style={{ fontSize: 56, marginBottom: 12 }}>🎰</div>
          <div style={{ fontSize: 16, fontWeight: 800, color: C.text, marginBottom: 6 }}>¡Tu tanda está lista!</div>
          <div style={{ fontSize: 13, color: C.textMd, marginBottom: 20, lineHeight: 1.6 }}>
            Todos los participantes se unieron.<br />Gira la tómbola para descubrir tu turno.
          </div>
          <Btn onClick={iniciarSorteo} style={{ maxWidth: 240, margin: '0 auto' }}>🎰 ¡Girar la tómbola!</Btn>
        </div>
      )}
      {fase === 'girando' && (
        <div>
          <div style={{ position: 'relative', width: 120, height: 120, margin: '0 auto 20px' }}>
            <div style={{ position: 'absolute', inset: 0, borderRadius: '50%', border: '4px solid transparent', borderTopColor: C.primary, borderRightColor: C.accent, animation: 'spin 0.6s linear infinite' }} />
            <div style={{ position: 'absolute', inset: 8, borderRadius: '50%', background: `linear-gradient(135deg,${C.primaryLt},${C.primaryMd})`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ fontSize: 42, fontWeight: 900, color: C.primary, fontFamily: 'monospace', animation: 'pulso 0.3s ease-in-out infinite' }}>{numMostrado}</div>
            </div>
          </div>
          <div style={{ fontSize: 14, fontWeight: 700, color: C.textMd }}>Sorteando tu turno...</div>
        </div>
      )}
      {fase === 'resultado' && (
        <div>
          <div style={{ position: 'relative', width: 120, height: 120, margin: '0 auto 16px' }}>
            <div style={{ position: 'absolute', inset: 0, borderRadius: '50%', border: `4px solid ${C.success}` }} />
            <div style={{ position: 'absolute', inset: 8, borderRadius: '50%', background: C.successLt, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ fontSize: 42, fontWeight: 900, color: C.success, fontFamily: 'monospace' }}>{turnoAsignado}</div>
            </div>
          </div>
          <div style={{ fontSize: 20, fontWeight: 900, color: C.text, marginBottom: 4 }}>🎉 ¡Te tocó el turno #{turnoAsignado}!</div>
          <div style={{ fontSize: 13, color: C.textMd, marginBottom: 20, lineHeight: 1.6 }}>
            Cobrarás tu tanda en la semana {turnoAsignado}.<br />¡Bienvenido a la tanda!
          </div>
          <Btn onClick={onConfirmar} style={{ maxWidth: 240, margin: '0 auto' }}>✅ ¡Entrar a mi tanda!</Btn>
        </div>
      )}
    </div>
  );
}

// ─── DETALLE TANDA ─────────────────────────────────────────
function DetalleTanda({ participante: participanteInicial, onBack, onMenu }) {
  const [participante, setParticipante] = useState(participanteInicial);
  const tanda = participante.tandas;
  const tieneturnoNoVisto = participante.turno && !participante.turno_visto;
  const [pagos, setPagos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [subiendo, setSubiendo] = useState(false);
  const [copiado, setCopiado] = useState(false);
  const [copiadoTarjeta, setCopiadoTarjeta] = useState(false);
  const [copiadoRef, setCopiadoRef] = useState(false);
  const [copiadoBanco, setCopiadoBanco] = useState(false);
  const [copiadoMonto, setCopiadoMonto] = useState(false);

  const copiar = (texto, setFn) => {
    navigator.clipboard.writeText(texto);
    setFn(true);
    setTimeout(() => setFn(false), 2000);
  };
  const [archivo, setArchivo] = useState({ file: null, preview: null });
  const [toast, setToast] = useState({ msg: '', type: '' });
  const [otrosParticipantes, setOtrosParticipantes] = useState([]);
  const [turnosDisponibles, setTurnosDisponibles] = useState([]);
  const [modalProrroga, setModalProrroga] = useState(false);
  const [solicitandoProrroga, setSolicitandoProrroga] = useState(false);

  const showToast = (msg, type = 'info') => { setToast({ msg, type }); setTimeout(() => setToast({ msg: '', type: '' }), 4000); };

  // Siempre mostrar opciones de pago (ya no solo viernes)
  const esViernes = true;

  // Calcular próximo domingo (fecha límite de la prórroga)
  const proximoDomingo = (() => {
    const hoy = new Date();
    const dias = (7 - hoy.getDay()) % 7 || 7; // días hasta el próximo domingo
    const domingo = new Date(hoy);
    domingo.setDate(hoy.getDate() + dias);
    return domingo.toLocaleDateString('es-MX', { weekday: 'long', day: 'numeric', month: 'long' });
  })();

  useEffect(() => {
    cargarPagos(); cargarParticipantes();
    // Polling cada 30s para detectar cambios de estado (admin confirma pago, etc.)
    const interval = setInterval(cargarPagos, 30000);
    return () => clearInterval(interval);
  }, []); // eslint-disable-line

  const cargarPagos = async () => {
    const { data } = await supabase.from('pagos').select('*').eq('participante_id', participante.id).order('semana');
    setPagos(data || []); setLoading(false);
  };

  const cargarParticipantes = async () => {
    const { data } = await supabase.from('participantes').select('*, usuarios(nombre, codigo_ref, nivel)').eq('tanda_id', tanda.id).order('turno');
    if (data) {
      setOtrosParticipantes(data);
      const turnosTomados = data.map(p => p.turno).filter(Boolean);
      const todos = Array.from({ length: tanda.semanas }, (_, i) => i + 1);
      const disponibles = todos.filter(n => !turnosTomados.includes(n));
      setTurnosDisponibles(disponibles);
    }
  };

  const asignarTurno = async (turno) => {
    const { error } = await supabase.from('participantes').update({ turno }).eq('id', participante.id);
    if (error) { showToast('Error al guardar turno: ' + error.message, 'error'); return; }
    setParticipante(p => ({ ...p, turno }));
    showToast(`¡Turno #${turno} guardado! 🎉`, 'success');
    cargarParticipantes();
  };

  const copiarClabe = () => {
    navigator.clipboard.writeText(tanda?.clabe || '');
    setCopiado(true); showToast('CLABE copiada ✓', 'success'); setTimeout(() => setCopiado(false), 2000);
  };

  const solicitarProrroga = async () => {
    setSolicitandoProrroga(true);
    try {
      await supabase.from('auditoria').insert({
        usuario_id: participante.usuario_id,
        accion: 'prorroga_solicitada',
        detalle: JSON.stringify({ tanda_id: tanda?.id, semana: tanda?.semana_actual, fecha: new Date().toISOString() })
      });
      await audit('prorroga_solicitada', { tanda_id: tanda?.id, semana: tanda?.semana_actual });
      setModalProrroga(false);
      showToast('Prórroga solicitada. El admin la revisará pronto.', 'info');
    } catch(e) {
      showToast('Error al solicitar prórroga', 'error');
    }
    setSolicitandoProrroga(false);
  };

  const TIPOS_PERMITIDOS = {
    'image/jpeg': [0xFF, 0xD8, 0xFF],
    'image/png':  [0x89, 0x50, 0x4E, 0x47],
    'image/webp': [0x52, 0x49, 0x46, 0x46],
    'image/heic': null, // HEIC no tiene magic bytes estándar, aceptar por tipo
    'application/pdf': [0x25, 0x50, 0x44, 0x46],
  };

  const validarMagicBytes = (file) => new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const bytes = new Uint8Array(e.target.result);
      for (const [mime, magic] of Object.entries(TIPOS_PERMITIDOS)) {
        if (!magic) { if (file.type === mime) { resolve(true); return; } continue; }
        if (magic.every((b, i) => bytes[i] === b)) { resolve(true); return; }
      }
      resolve(false);
    };
    reader.readAsArrayBuffer(file.slice(0, 8));
  });

  const seleccionarArchivo = async (e) => {
    const file = e.target.files[0]; if (!file) return;
    if (file.size > 10 * 1024 * 1024) { showToast('El archivo no puede pesar más de 10 MB', 'error'); return; }
    const tipoValido = await validarMagicBytes(file);
    if (!tipoValido) { showToast('Archivo no válido. Solo se aceptan fotos (JPG, PNG, WEBP) o PDF', 'error'); return; }
    if (file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = (ev) => setArchivo({ file, preview: ev.target.result });
      reader.readAsDataURL(file);
    } else {
      setArchivo({ file, preview: null });
    }
  };

  const subirComprobante = async () => {
    if (!archivo.file || subiendo) return;
    setSubiendo(true);
    try {
      const ext = archivo.file.name.split('.').pop();
      const fileName = `${participante.id}_s${tanda?.semana_actual}_${Date.now()}.${ext}`;
      const { error: ue } = await supabase.storage.from('comprobantes').upload(fileName, archivo.file);
      if (ue) throw ue;
      // Guardar solo el path del archivo (no URL pública) — se genera signed URL al mostrar
      const comprobantePath = fileName;
      const existing = pagos.find(p => p.semana === tanda?.semana_actual);
      if (existing) {
        await supabase.from('pagos').update({ comprobante_url: comprobantePath, pagado: false, motivo_rechazo: null, estado_comprobante: 'en_revision' }).eq('id', existing.id);
      } else {
        await supabase.from('pagos').insert({ participante_id: participante.id, semana: tanda?.semana_actual, pagado: false, comprobante_url: comprobantePath, estado_comprobante: 'en_revision' });
      }
      await audit('comprobante_subido', { participante_id: participante.id, tanda_id: tanda?.id, semana: tanda?.semana_actual });
      showToast('¡Comprobante enviado! El admin lo verifica en menos de 24 hrs ✓', 'success');
      setArchivo({ file: null, preview: null });
      cargarPagos();
    } catch (err) { showToast('Error: ' + err.message, 'error'); }
    setSubiendo(false);
  };

  const pagoActual = pagos.find(p => p.semana === tanda?.semana_actual);
  const sinTurno = !participante.turno;
  const esSemanaYoCobro = participante.turno === tanda?.semana_actual;
  const [mostrarBannerCobro, setMostrarBannerCobro] = useState(esSemanaYoCobro);
  const [confetiBanner, setConfetiBanner] = useState(esSemanaYoCobro);

  // Tanda completada: estado terminada O último pago confirmado
  const todosLosPagosConfirmados = !loading && pagos.length > 0 && pagos.filter(p => p.pagado).length >= (tanda?.semanas || 999);
  const tandaTerminada = tanda?.estado === 'terminada' || todosLosPagosConfirmados;
  const [mostrarCelebracion, setMostrarCelebracion] = useState(false);
  const [confetiTerminada, setConfetiTerminada] = useState(false);
  const [celebracionMostrada, setCelebracionMostrada] = useState(false);

  useEffect(() => {
    if (esSemanaYoCobro) {
      setTimeout(() => setConfetiBanner(false), 4000);
    }
  }, []); // eslint-disable-line

  const [puntosUsuario, setPuntosUsuario] = useState(null);

  // Mostrar celebración cuando se detecta que la tanda terminó (después de cargar pagos)
  useEffect(() => {
    if (tandaTerminada && !celebracionMostrada && !loading) {
      setMostrarCelebracion(true);
      setConfetiTerminada(true);
      setCelebracionMostrada(true);
      setTimeout(() => setConfetiTerminada(false), 5000);
      // Fetch puntos actualizados del usuario
      supabase.from('usuarios').select('puntos, nivel, tandas_completadas').eq('id', participante.usuario_id).single()
        .then(({ data }) => { if (data) setPuntosUsuario(data); });
    }
  }, [tandaTerminada, loading]); // eslint-disable-line

  // Calcular puntos ganados en esta tanda
  const puntosEstaTanda = (() => {
    if (!tandaTerminada || loading) return null;
    const pagosConfirmados = pagos.filter(p => p.pagado);
    const aTiempo = pagosConfirmados.filter(p => !p.pago_tardio).length;
    const tardios = pagosConfirmados.filter(p => p.pago_tardio).length;
    const creditos = (aTiempo * 2) + (tardios * 1);
    const max = (tanda?.semanas || 1) * 2;
    return { puntos: Math.round(10 * creditos / max), aTiempo, tardios };
  })();

  return (
    <div style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <Toast msg={toast.msg} type={toast.type} />

      {/* Modal celebración: tanda completada */}
      {mostrarCelebracion && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 24px' }}>
          <style>{`
            @keyframes celebrar-pulso{0%,100%{transform:scale(1)}50%{transform:scale(1.05)}}
            @keyframes celebrar-caer{0%{transform:translateY(-30px) rotate(0deg);opacity:1}100%{transform:translateY(400px) rotate(720deg);opacity:0}}
            @keyframes celebrar-estrella{0%{transform:scale(0) rotate(0deg);opacity:0}50%{transform:scale(1.2) rotate(180deg);opacity:1}100%{transform:scale(1) rotate(360deg);opacity:1}}
          `}</style>
          {confetiTerminada && Array.from({ length: 40 }, (_, i) => (
            <div key={i} style={{
              position: 'fixed', left: `${Math.random() * 100}%`, top: -10,
              width: 8 + Math.random() * 10, height: 8 + Math.random() * 10,
              background: ['#1A56DB','#059669','#F59E0B','#EF4444','#8B5CF6','#0EA5E9','#EC4899'][i % 7],
              borderRadius: i % 3 === 0 ? '50%' : 2,
              animation: `celebrar-caer ${2.5 + Math.random() * 2}s ${Math.random() * 1}s ease-in forwards`,
              zIndex: 701, pointerEvents: 'none',
            }} />
          ))}
          <div style={{ background: '#fff', borderRadius: 24, padding: '40px 28px', textAlign: 'center', maxWidth: 360, width: '100%', position: 'relative', zIndex: 702, animation: 'celebrar-pulso 2s ease-in-out infinite' }}>
            <div style={{ fontSize: 72, marginBottom: 16, animation: 'celebrar-estrella 1s ease-out' }}>🏆</div>
            <div style={{ fontSize: 24, fontWeight: 900, color: '#1E293B', marginBottom: 8 }}>Tanda completada</div>
            <div style={{ fontSize: 16, fontWeight: 800, color: '#059669', marginBottom: 16 }}>{tanda?.nombre}</div>
            <div style={{ fontSize: 14, color: '#64748B', lineHeight: 1.6, marginBottom: 8 }}>
              Completaste las {tanda?.semanas} semanas exitosamente.
            </div>
            <div style={{ fontSize: 14, color: '#64748B', lineHeight: 1.6, marginBottom: 8 }}>
              {puntosEstaTanda?.tardios > 0
                ? `${puntosEstaTanda.aTiempo} pagos a tiempo, ${puntosEstaTanda.tardios} con amonestacion.`
                : 'Todos tus pagos fueron a tiempo!'}
            </div>
            {puntosUsuario && (
              <div style={{ fontSize: 13, color: '#1A56DB', fontWeight: 700, marginBottom: 20 }}>
                Nivel: {puntosUsuario.nivel} · Total: {puntosUsuario.puntos} pts
              </div>
            )}
            <div style={{ display: 'flex', gap: 10, justifyContent: 'center', marginBottom: 24 }}>
              <div style={{ background: '#F0FDF4', borderRadius: 12, padding: '12px 14px', textAlign: 'center', flex: 1 }}>
                <div style={{ fontSize: 10, color: '#059669', fontWeight: 700 }}>SEMANAS</div>
                <div style={{ fontSize: 20, fontWeight: 900, color: '#059669' }}>{tanda?.semanas}</div>
              </div>
              <div style={{ background: '#EFF6FF', borderRadius: 12, padding: '12px 14px', textAlign: 'center', flex: 1 }}>
                <div style={{ fontSize: 10, color: '#1A56DB', fontWeight: 700 }}>TANDA</div>
                <div style={{ fontSize: 20, fontWeight: 900, color: '#1A56DB' }}>{fmt((tanda?.monto || 0) * (tanda?.semanas || 0))}</div>
              </div>
              <div style={{ background: '#FEF9C3', borderRadius: 12, padding: '12px 14px', textAlign: 'center', flex: 1 }}>
                <div style={{ fontSize: 10, color: '#854D0E', fontWeight: 700 }}>PUNTOS</div>
                <div style={{ fontSize: 20, fontWeight: 900, color: '#854D0E' }}>+{puntosEstaTanda?.puntos || 0}</div>
              </div>
            </div>
            <Btn onClick={() => setMostrarCelebracion(false)} style={{ maxWidth: 240, margin: '0 auto' }}>Continuar</Btn>
          </div>
        </div>
      )}

      {/* Modal banner: esta semana te toca cobrar */}
      {mostrarBannerCobro && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 24px' }}>
          {/* Confeti */}
          {confetiBanner && Array.from({ length: 30 }, (_, i) => (
            <div key={i} style={{
              position: 'absolute',
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 40}%`,
              width: 8 + Math.random() * 6,
              height: 8 + Math.random() * 6,
              background: ['#1A56DB','#0EA5E9','#059669','#F59E0B','#EF4444','#8B5CF6','#EC4899'][i % 7],
              borderRadius: i % 3 === 0 ? '50%' : 2,
              animation: `caer ${2 + Math.random()}s ${Math.random() * 0.8}s ease-in forwards`,
              zIndex: 601,
              pointerEvents: 'none',
            }} />
          ))}
          <div style={{ background: '#fff', borderRadius: 20, padding: '32px 24px', textAlign: 'center', maxWidth: 320, width: '100%', position: 'relative', zIndex: 602, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
            <div style={{ fontSize: 64, marginBottom: 12 }}>🎉</div>
            <div style={{ fontSize: 22, fontWeight: 900, color: '#1E293B', marginBottom: 8, lineHeight: 1.2 }}>
              ¡Esta semana<br />te toca cobrar!
            </div>
            <div style={{ fontSize: 14, fontWeight: 800, color: '#059669', marginBottom: 16 }}>
              Tu tanda: {fmt((tanda?.monto || 0) * (tanda?.semanas || 0))}
            </div>
            <div style={{ background: '#FEF3C7', border: '1.5px solid #FDE68A', borderRadius: 12, padding: '12px 14px', marginBottom: 20, fontSize: 13, color: '#92400E', lineHeight: 1.7, textAlign: 'left' }}>
              <strong>⚠️ Importante:</strong> Para recibir tu tanda necesitas depositar tu aportación semanal de <strong>{fmt(tanda?.monto)}</strong> primero. En cuanto confirmemos tu pago, te hacemos la transferencia.
            </div>
            <button onClick={() => setMostrarBannerCobro(false)} style={{ background: '#1A56DB', color: '#fff', border: 'none', borderRadius: 12, padding: '13px 0', width: '100%', fontSize: 15, fontWeight: 800, cursor: 'pointer', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              ¡Entendido, voy a depositar!
            </button>
          </div>
        </div>
      )}

      <div style={{ background: C.white, borderBottom: `1px solid ${C.gray200}`, padding: '0 16px', height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
        <button onClick={onBack} style={{ background: C.primaryLt, border: `1.5px solid ${C.primaryMd}`, color: C.primary, fontSize: 15, fontWeight: 800, cursor: 'pointer', fontFamily: "'Plus Jakarta Sans', sans-serif", borderRadius: 10, padding: '8px 16px', display: 'flex', alignItems: 'center', gap: 6 }}>
          ← Mis Tandas
        </button>
        <button onClick={onMenu} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 8, display: 'flex', flexDirection: 'column', gap: 5 }}>
          {[0,1,2].map(i => <div key={i} style={{ width: 26, height: 2.5, background: C.text, borderRadius: 99 }} />)}
        </button>
      </div>
      <div style={{ padding: '16px 16px 40px', background: C.gray50, minHeight: '100vh' }}>

        {/* Card resumen tanda */}
        <Card style={{ marginBottom: 16, background: `linear-gradient(135deg,${C.primaryLt},${C.white})` }}>
          <div style={{ fontSize: 20, fontWeight: 900, color: C.text, marginBottom: 14 }}>{tanda?.nombre}</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
            {[
              ['Aportación semanal', fmt(tanda?.monto)],
              ['Tu turno', sinTurno ? '🎰 Por sortear' : `#${participante.turno}`],
              ['Semana actual', `${tanda?.semana_actual} de ${tanda?.semanas}`],
              ['Tu tanda completa', fmt((tanda?.monto || 0) * (tanda?.semanas || 0))],
            ].map(([l, v]) => (
              <div key={l}>
                <div style={{ fontSize: 12, color: C.textLt, marginBottom: 4 }}>{l}</div>
                <div style={{ fontSize: 17, fontWeight: 800, color: sinTurno && l === 'Tu turno' ? C.warning : C.text }}>{v}</div>
              </div>
            ))}
          </div>
          <div style={{ background: C.gray200, borderRadius: 99, height: 6, overflow: 'hidden' }}>
            <div style={{ width: `${Math.min(100, ((tanda?.semana_actual || 0) / (tanda?.semanas || 1)) * 100)}%`, height: '100%', background: C.primary, borderRadius: 99 }} />
          </div>
        </Card>

        {/* TOMBOLA — turno asignado pero no visto aún */}
        {tieneturnoNoVisto && (
          <Card style={{ marginBottom: 16, border: `2px solid ${C.primary}`, background: `linear-gradient(160deg,${C.primaryLt},${C.white})` }}>
            <Tombola turnoAsignado={participante.turno} totalSemanas={tanda?.semanas} onConfirmar={async () => {
              await supabase.from('participantes').update({ turno_visto: true }).eq('id', participante.id);
              setParticipante(p => ({ ...p, turno_visto: true }));
            }} />
          </Card>
        )}

        {/* Esperando participantes — si no tiene turno y la tanda no está llena */}
        {sinTurno && otrosParticipantes.length < tanda.semanas && (
          <Card style={{ marginBottom: 16, textAlign: 'center', padding: 32 }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>⏳</div>
            <div style={{ fontSize: 16, fontWeight: 800, color: C.text, marginBottom: 8 }}>Esperando participantes</div>
            <div style={{ fontSize: 13, color: C.textMd, lineHeight: 1.7 }}>
              Estamos esperando a que se unan más personas para iniciar la tanda. Actualmente hay <strong>{otrosParticipantes.length} de {tanda.semanas}</strong> participantes.
            </div>
            <div style={{ background: C.gray200, borderRadius: 99, height: 8, overflow: 'hidden', marginTop: 16 }}>
              <div style={{ width: `${(otrosParticipantes.length / tanda.semanas) * 100}%`, height: '100%', background: C.primary, borderRadius: 99 }} />
            </div>
            <div style={{ fontSize: 11, color: C.textLt, marginTop: 6, marginBottom: 16 }}>Te avisaremos cuando esté lista</div>
            <button onClick={() => {
              const codigoRef = participante?.usuarios?.codigo_ref || '';
              const codigoReferido = 'TC' + codigoRef;
              const mensaje = `¡Hola! 🤝 Te invito a que te unas a mi tanda "${tanda?.nombre}" en TandaClick.\n\n` +
                `Es una tanda de ${fmt(tanda?.monto)} ${(tanda?.frecuencia || 'Semanal').toLowerCase()} por ${tanda?.semanas} ${tanda?.frecuencia === 'Mensual' ? 'meses' : tanda?.frecuencia === 'Quincenal' ? 'quincenas' : 'semanas'}.\n\n` +
                `Para registrarte:\n` +
                `1. Entra a tandaclick.com\n` +
                `2. Da click en "Registrarse" y crea tu cuenta\n` +
                `3. Usa mi código de referido: ${codigoReferido}\n\n` +
                `TandaClick es una plataforma digital de tandas, segura y con comprobante de cada peso. ¡Únete!`;
              navigator.clipboard.writeText(mensaje);
              showToast('Mensaje copiado — pégalo en WhatsApp', 'success');
            }} style={{
              width: '100%', padding: '14px 0', borderRadius: 12, border: 'none',
              background: '#25D366', color: '#fff', fontSize: 14, fontWeight: 700,
              cursor: 'pointer', fontFamily: "'Plus Jakarta Sans', sans-serif",
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
            }}>
              💬 Invita a alguien a esta tanda
            </button>
          </Card>
        )}

        {/* Si ya tiene turno y lo vio: fechas + CLABE + pago + historial */}
        {!sinTurno && !tieneturnoNoVisto && !loading && (() => {
          // Calcular fechas de la semana actual
          // Forzar medianoche CDMX (UTC-6 estándar, UTC-5 en horario de verano)
          const fechaInicio = tanda?.fecha_inicio ? new Date(tanda.fecha_inicio + 'T00:00:00-06:00') : null;
          let fechaLimite = null;
          let fechaProrroga = null;
          let fechaPago = null;
          if (fechaInicio) {
            const semanaActual = (tanda?.semana_actual || 1) - 1;
            const inicioSemana = new Date(fechaInicio);
            inicioSemana.setDate(inicioSemana.getDate() + (semanaActual * 7));
            // Buscar el próximo domingo desde el inicio del periodo
            fechaLimite = new Date(inicioSemana);
            const diaSem = fechaLimite.getDay(); // 0=domingo
            const diasAlDomingo = diaSem === 0 ? 7 : 7 - diaSem;
            fechaLimite.setDate(fechaLimite.getDate() + diasAlDomingo);
            fechaProrroga = new Date(fechaLimite);
            fechaProrroga.setDate(fechaProrroga.getDate() + 1); // Lunes
            fechaPago = new Date(fechaProrroga);
            fechaPago.setDate(fechaPago.getDate() + 2); // Miércoles
          }
          const formatFecha = (d) => d ? d.toLocaleDateString('es-MX', { weekday: 'long', day: 'numeric', month: 'long' }) : '—';
          const hoy = new Date();
          const pagoConfirmado = pagoActual?.pagado === true;
          const vencido = !pagoConfirmado && fechaLimite && hoy > fechaLimite;
          const enProrroga = !pagoConfirmado && fechaProrroga && hoy > fechaLimite && hoy <= fechaProrroga;

          return (
          <>
            {/* Fechas importantes */}
            {fechaLimite && (
              <Card style={{ marginBottom: 16, background: pagoConfirmado ? `linear-gradient(135deg, ${C.successLt}, #fff)` : vencido && !enProrroga ? `linear-gradient(135deg, #FEF2F2, #fff)` : enProrroga ? `linear-gradient(135deg, #FEF3C7, #fff)` : `linear-gradient(135deg, ${C.primaryLt}, #fff)`, border: `1.5px solid ${pagoConfirmado ? '#86EFAC' : vencido && !enProrroga ? '#FCA5A5' : enProrroga ? '#FDE68A' : C.primaryMd}` }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: pagoConfirmado ? C.success : vencido ? C.danger : C.textMd, marginBottom: 6, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                    {pagoConfirmado ? '✅ PAGO CONFIRMADO' : enProrroga ? '⚠️ EN PRÓRROGA' : vencido ? '❌ PLAZO VENCIDO' : '📅 FECHA LÍMITE DE PAGO'}
                  </div>
                  <div style={{ fontSize: 22, fontWeight: 900, color: pagoConfirmado ? C.success : vencido ? C.danger : C.primary, marginBottom: 12 }}>
                    {pagoConfirmado ? formatFecha(fechaLimite) : formatFecha(fechaLimite)}
                  </div>
                  <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
                    <div style={{ background: enProrroga ? '#FEF3C7' : C.gray50, borderRadius: 8, padding: '8px 12px', textAlign: 'center' }}>
                      <div style={{ fontSize: 10, color: C.textLt }}>PRÓRROGA</div>
                      <div style={{ fontSize: 12, fontWeight: 700, color: enProrroga ? C.warning : C.text }}>{formatFecha(fechaProrroga)}</div>
                    </div>
                    <div style={{ background: C.gray50, borderRadius: 8, padding: '8px 12px', textAlign: 'center' }}>
                      <div style={{ fontSize: 10, color: C.textLt }}>DÍA DE PAGO</div>
                      <div style={{ fontSize: 12, fontWeight: 700, color: C.success }}>{formatFecha(fechaPago)}</div>
                    </div>
                  </div>
                </div>
              </Card>
            )}

            <Card style={{ marginBottom: 16 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: C.textMd, marginBottom: 14 }}>💳 DATOS PARA DEPOSITAR</div>

              {/* Fila helper */}
              {[
                { label: 'Banco', valor: 'Spin by OXXO', copiar: 'Spin by OXXO', state: copiadoBanco, setFn: setCopiadoBanco },
                { label: 'Beneficiario', valor: 'TandaClick', copiar: 'TandaClick', state: copiadoRef, setFn: setCopiadoRef },
                { label: 'Monto a depositar', valor: fmt(tanda?.monto), copiar: String(tanda?.monto || ''), state: copiadoMonto, setFn: setCopiadoMonto },
                { label: 'CLABE', valor: tanda?.clabe || '—', copiar: tanda?.clabe || '', state: copiado, setFn: setCopiado, mono: true, destacado: true },
                // TODO: mover a tabla config en Supabase
                { label: 'Tarjeta OXXO', valor: '4217 4702 5778 7131', copiar: '4217470257787131', state: copiadoTarjeta, setFn: setCopiadoTarjeta, mono: true },
                { label: 'No. Cliente', valor: participante?.usuarios?.codigo_ref || usuario?.codigo_ref || '—', copiar: participante?.usuarios?.codigo_ref || usuario?.codigo_ref || '', state: copiadoRef, setFn: setCopiadoRef, mono: true, nota: 'Úsalo como concepto de pago' },
              ].map((item, i) => (
                <div key={i} style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  padding: '11px 0',
                  borderBottom: i < 5 ? `1px solid ${C.gray100}` : 'none',
                }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 11, color: C.textLt, marginBottom: 2 }}>{item.label}</div>
                    <div style={{
                      fontSize: item.destacado ? 16 : 14,
                      fontWeight: item.destacado ? 900 : 700,
                      color: item.destacado ? C.primary : C.text,
                      fontFamily: item.mono ? 'monospace' : "'Plus Jakarta Sans', sans-serif",
                      letterSpacing: item.mono ? '0.05em' : 0,
                      wordBreak: 'break-all',
                    }}>{item.valor}</div>
                    {item.nota && <div style={{ fontSize: 11, color: C.primary, marginTop: 2 }}>{item.nota}</div>}
                  </div>
                  {item.setFn && (
                    <button onClick={() => copiar(item.copiar, item.setFn)} style={{
                      marginLeft: 12, flexShrink: 0,
                      padding: '7px 12px', borderRadius: 8,
                      border: `1px solid ${item.state ? C.success : C.primaryMd}`,
                      background: item.state ? C.successLt : C.primaryLt,
                      color: item.state ? C.success : C.primary,
                      fontSize: 12, fontWeight: 700, cursor: 'pointer',
                      fontFamily: "'Plus Jakarta Sans', sans-serif",
                      whiteSpace: 'nowrap',
                    }}>
                      {item.state ? '✓' : '📋'}
                    </button>
                  )}
                </div>
              ))}
            </Card>
            <Card style={{ marginBottom: 16 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: C.textMd, marginBottom: 12 }}>SEMANA {tanda?.semana_actual} — TU PAGO</div>

              {participante.turno === tanda?.semana_actual && (
                <div style={{ background: 'linear-gradient(135deg,#FEF9C3,#FEF3C7)', border: '1.5px solid #FDE68A', borderRadius: 12, padding: '14px 16px', marginBottom: 14 }}>
                  <div style={{ fontSize: 17, fontWeight: 900, color: C.warning, marginBottom: 8 }}>🎉 ¡Esta semana te toca cobrar!</div>
                  <div style={{ fontSize: 13, color: C.text, lineHeight: 1.8 }}>
                    Para recibir tu tanda de <strong>{fmt((tanda?.monto || 0) * (tanda?.semanas || 0))}</strong>, necesitas depositar tu aportación de <strong>{fmt(tanda?.monto)}</strong> primero. Una vez que confirmemos tu pago, te hacemos la transferencia.
                  </div>
                </div>
              )}

              {pagoActual && pagoActual.estado_comprobante !== 'rechazado' ? (
                <div style={{ background: pagoActual.pagado ? C.successLt : C.warningLt, borderRadius: 12, padding: 16, textAlign: 'center' }}>
                  <div style={{ fontSize: 28, marginBottom: 8 }}>{pagoActual.pagado ? '✅' : '⏳'}</div>
                  <div style={{ fontSize: 14, fontWeight: 800, color: pagoActual.pagado ? C.success : C.warning }}>
                    {pagoActual.pagado
                      ? participante.turno === tanda?.semana_actual ? 'Pago confirmado — te enviamos tu tanda en breve 🎉' : 'Pago confirmado'
                      : pagoActual.estado_comprobante === 'rechazado' ? '❌ Comprobante rechazado'
                      : 'En revisión — verificamos en menos de 24 hrs'}
                  </div>
                </div>
              ) : (
                <div>
                  {/* Banner motivo de rechazo */}
                  {pagoActual?.estado_comprobante === 'rechazado' && pagoActual?.motivo_rechazo && (
                    <div style={{ background: '#FEF2F2', border: '2px solid #FECACA', borderRadius: 12, padding: '14px 16px', marginBottom: 16 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                        <span style={{ fontSize: 20 }}>❌</span>
                        <div style={{ fontSize: 14, fontWeight: 900, color: '#DC2626' }}>Comprobante rechazado</div>
                      </div>
                      <div style={{ background: '#fff', border: '1px solid #FECACA', borderRadius: 8, padding: '10px 12px', marginBottom: 8 }}>
                        <div style={{ fontSize: 11, fontWeight: 700, color: '#9CA3AF', marginBottom: 4 }}>MOTIVO DEL RECHAZO</div>
                        <div style={{ fontSize: 13, fontWeight: 700, color: '#7F1D1D' }}>⚠️ {pagoActual.motivo_rechazo}</div>
                      </div>
                      <div style={{ fontSize: 12, color: '#B91C1C', lineHeight: 1.6 }}>Corrige el problema y sube un nuevo comprobante 👇</div>
                    </div>
                  )}
                  <div style={{ background: C.dangerLt, borderRadius: 12, padding: 16, textAlign: 'center', marginBottom: 12 }}>
                    <div style={{ fontSize: 28, marginBottom: 8 }}>⚠️</div>
                    <div style={{ fontSize: 16, fontWeight: 800, color: C.danger }}>Depósito pendiente — {fmt(tanda?.monto)}</div>
                  </div>
                  {participante.turno !== tanda?.semana_actual && (
                    <div style={{ fontSize: 12, color: C.textMd, lineHeight: 1.6, marginBottom: 12, padding: '0 4px' }}>
                      💡 Todos los participantes depositan cada semana para que quien tenga el turno pueda cobrar su tanda.
                    </div>
                  )}

                  {/* Modal confirmación prórroga */}
                  {modalProrroga && (
                    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 999, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
                      <div style={{ background: C.white, borderRadius: '20px 20px 0 0', padding: '24px 20px 32px', width: '100%', maxWidth: 480, maxHeight: '90vh', overflowY: 'auto' }}>

                        {/* Encabezado */}
                        <div style={{ textAlign: 'center', marginBottom: 18 }}>
                          <div style={{ fontSize: 44, marginBottom: 8 }}>⚠️</div>
                          <div style={{ fontSize: 18, fontWeight: 900, color: C.text, marginBottom: 8 }}>¿Solicitar prórroga?</div>
                          <div style={{ fontSize: 14, color: C.textMd, lineHeight: 1.7 }}>
                            Tu pago de <strong>{fmt(tanda?.monto)}</strong> está pendiente. Si necesitas más tiempo, tienes plazo hasta el
                          </div>
                          <div style={{ fontSize: 16, fontWeight: 900, color: C.primary, marginTop: 6 }}>
                            🗓 {proximoDomingo} al finalizar el día
                          </div>
                        </div>

                        {/* Cómo pagar */}
                        <div style={{ background: C.primaryLt, border: `1px solid ${C.primaryMd}`, borderRadius: 12, padding: '14px 16px', marginBottom: 14 }}>
                          <div style={{ fontSize: 13, fontWeight: 800, color: C.primary, marginBottom: 10 }}>💳 Cómo realizar tu pago antes del domingo</div>
                          <div style={{ fontSize: 13, color: C.text, lineHeight: 1.9 }}>
                            <strong>📱 Transferencia SPEI:</strong><br/>
                            CLABE: <span style={{ fontFamily: 'monospace', fontWeight: 900, color: C.primary, letterSpacing: '0.05em' }}>{tanda?.clabe || '—'}</span>
                            <button onClick={() => { navigator.clipboard.writeText(tanda?.clabe || ''); }} style={{ marginLeft: 8, fontSize: 11, padding: '2px 8px', borderRadius: 6, border: `1px solid ${C.primaryMd}`, background: C.primaryLt, color: C.primary, cursor: 'pointer', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>Copiar</button>
                            <br/>Sube el comprobante en la app una vez transferido.<br/><br/>
                            <strong>🏪 Depósito en OXXO:</strong><br/>
                            Tarjeta: <span style={{ fontFamily: 'monospace', fontWeight: 900, color: C.primary, letterSpacing: '0.05em' }}>4217 4702 5778 7131</span>
                            <button onClick={() => { navigator.clipboard.writeText('4217470257787131'); }} style={{ marginLeft: 8, fontSize: 11, padding: '2px 8px', borderRadius: 6, border: `1px solid ${C.primaryMd}`, background: C.primaryLt, color: C.primary, cursor: 'pointer', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>Copiar</button>
                            <br/>Ve a cualquier OXXO, deposita con el número de tarjeta y sube la foto del ticket.
                          </div>
                        </div>

                        {/* Advertencia amonestación */}
                        <div style={{ background: '#FEF2F2', border: '1.5px solid #FECACA', borderRadius: 12, padding: '14px 16px', marginBottom: 14 }}>
                          <div style={{ fontSize: 13, fontWeight: 900, color: '#DC2626', marginBottom: 8 }}>🚨 Al solicitar esta prórroga se registrará una amonestación</div>
                          {[
                            'Se descuentan puntos de tu score de confianza',
                            'Queda registrada permanentemente en tu historial',
                            'Acumular amonestaciones puede bajar tu nivel en la plataforma',
                          ].map((item, i) => (
                            <div key={i} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', marginBottom: 4 }}>
                              <span style={{ color: '#DC2626', flexShrink: 0, marginTop: 1 }}>•</span>
                              <span style={{ fontSize: 12, color: '#7F1D1D', lineHeight: 1.6 }}>{item}</span>
                            </div>
                          ))}
                        </div>

                        {/* Advertencia expulsión */}
                        <div style={{ background: '#1F2937', borderRadius: 12, padding: '14px 16px', marginBottom: 20 }}>
                          <div style={{ fontSize: 13, fontWeight: 900, color: '#F87171', marginBottom: 6 }}>⛔ Si no pagas antes del domingo</div>
                          <div style={{ fontSize: 12, color: '#D1D5DB', lineHeight: 1.7 }}>
                            El incumplimiento reiterado de pagos puede derivar en la <strong style={{ color: '#FCA5A5' }}>suspensión o expulsión definitiva</strong> de TandaClick, retención de tu depósito de seguridad y reporte al <strong style={{ color: '#FCA5A5' }}>Buró de Crédito</strong>.
                          </div>
                        </div>

                        <Btn onClick={solicitarProrroga} disabled={solicitandoProrroga} style={{ background: C.warning, border: `1px solid ${C.warning}`, marginBottom: 10, padding: '15px 0', fontSize: 15 }}>
                          {solicitandoProrroga ? 'Solicitando...' : '⏰ Entendido — solicitar prórroga'}
                        </Btn>
                        <Btn onClick={() => setModalProrroga(false)} variant="ghost" style={{ padding: '14px 0', fontSize: 14 }}>
                          Cancelar — voy a pagar ahora mismo
                        </Btn>
                      </div>
                    </div>
                  )}

                  {/* Paso 1: seleccionar archivo */}
                  {(!pagoActual || pagoActual?.estado_comprobante === 'rechazado') && !archivo.file && (
                    <label style={{ display: 'block', background: C.gray100, color: C.text, border: `2px dashed ${C.gray400}`, borderRadius: 12, padding: '20px', textAlign: 'center', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>
                      <div style={{ fontSize: 32, marginBottom: 8 }}>📎</div>
                      <div style={{ fontWeight: 800, color: C.text, marginBottom: 6, fontSize: 15 }}>Seleccionar comprobante</div>
                      <div style={{ fontSize: 13, color: C.textLt, fontWeight: 400 }}>Foto o PDF de tu transferencia</div>
                      <input type="file" accept="image/*,application/pdf" onChange={seleccionarArchivo} style={{ display: 'none' }} />
                    </label>
                  )}

                  {/* Paso 2: preview + confirmar */}
                  {archivo.file && (
                    <div>
                      {/* Preview imagen */}
                      {archivo.preview && (
                        <div style={{ marginBottom: 12, borderRadius: 12, overflow: 'hidden', border: `1px solid ${C.gray200}` }}>
                          <img src={archivo.preview} alt="Comprobante" style={{ width: '100%', maxHeight: 200, objectFit: 'cover', display: 'block' }} />
                        </div>
                      )}
                      {/* Nombre archivo */}
                      <div style={{ background: C.gray100, borderRadius: 10, padding: '10px 14px', marginBottom: 12, display: 'flex', alignItems: 'center', gap: 10 }}>
                        <span style={{ fontSize: 20 }}>{archivo.preview ? '🖼️' : '📄'}</span>
                        <div style={{ flex: 1, overflow: 'hidden' }}>
                          <div style={{ fontSize: 13, fontWeight: 700, color: C.text, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{archivo.file?.name}</div>
                          <div style={{ fontSize: 11, color: C.textLt }}>{archivo.file ? (archivo.file.size / 1024).toFixed(0) + " KB" : ""}</div>
                        </div>
                        <button onClick={() => setArchivo({ file: null, preview: null })} style={{ background: 'none', border: 'none', color: C.danger, fontSize: 18, cursor: 'pointer', padding: 4 }}>✕</button>
                      </div>
                      {/* Botón submit */}
                      <Btn onClick={subirComprobante} disabled={subiendo} style={{ background: C.success, border: `1px solid ${C.success}`, padding: '15px 0', fontSize: 15 }}>
                        {subiendo ? '⏳ Enviando...' : '✅ Confirmar y enviar comprobante'}
                      </Btn>
                      <label style={{ display: 'block', textAlign: 'center', marginTop: 10, fontSize: 12, color: C.primary, fontWeight: 700, cursor: 'pointer' }}>
                        Cambiar archivo
                        <input type="file" accept="image/*,application/pdf" onChange={seleccionarArchivo} style={{ display: 'none' }} />
                      </label>
                    </div>
                  )}
                </div>
              )}
            </Card>
            <Card style={{ marginBottom: 16 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: C.textMd, marginBottom: 12 }}>HISTORIAL DE PAGOS</div>
              {loading ? <div style={{ color: C.textLt, fontSize: 13 }}>Cargando...</div> : (
                <>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                    {Array.from({ length: tanda?.semanas || 0 }, (_, i) => {
                      const pago = pagos.find(p => p.semana === i + 1);
                      const esActual = i + 1 === tanda?.semana_actual;
                      return (
                        <div key={i} style={{ width: 34, height: 34, borderRadius: 8, fontSize: 10, fontWeight: 800, display: 'flex', alignItems: 'center', justifyContent: 'center', background: pago ? (pago.pagado ? C.successLt : pago.estado_comprobante === 'rechazado' ? C.dangerLt : C.warningLt) : esActual ? C.dangerLt : C.gray100, color: pago ? (pago.pagado ? C.success : pago.estado_comprobante === 'rechazado' ? C.danger : C.warning) : esActual ? C.danger : C.textLt, border: `1.5px solid ${pago ? (pago.pagado ? '#A7F3D0' : '#FDE68A') : esActual ? '#FCA5A5' : C.gray200}` }}>{i + 1}</div>
                      );
                    })}
                  </div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 12, fontSize: 11 }}>
                    <span style={{ color: C.success }}>■ Confirmado</span>
                    <span style={{ color: C.warning }}>■ En revisión</span>
                    <span style={{ color: C.danger }}>■ Pendiente</span>
                    <span style={{ color: C.textLt }}>■ Próximo</span>
                  </div>
                </>
              )}
            </Card>

            {/* Botón prórroga — después del historial */}
            {esViernes && (!pagoActual || pagoActual?.estado_comprobante === 'rechazado') && !archivo.file && (
              <button onClick={() => setModalProrroga(true)} style={{
                width: '100%', padding: '12px 0', borderRadius: 10, marginBottom: 16,
                background: 'none', border: `1.5px solid ${C.warning}`,
                color: C.warning, fontSize: 13, fontWeight: 700, cursor: 'pointer',
                fontFamily: "'Plus Jakarta Sans', sans-serif",
              }}>
                ⏰ Pedir prórroga de pago
              </button>
            )}
          </>
          );
        })()}

        {/* Participantes */}
        <Card>
          <div style={{ fontSize: 12, fontWeight: 700, color: C.textMd, marginBottom: 12 }}>👥 PARTICIPANTES ({otrosParticipantes.length} de {tanda?.semanas})</div>
          {otrosParticipantes.length === 0 ? (
            <div style={{ color: C.textLt, fontSize: 13 }}>Cargando...</div>
          ) : (
            otrosParticipantes.map((p, i) => (
              <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 0', borderBottom: i < otrosParticipantes.length - 1 ? `1px solid ${C.gray100}` : 'none' }}>
                <div style={{ width: 32, height: 32, borderRadius: '50%', background: p.turno ? C.primaryLt : C.gray100, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 900, color: p.turno ? C.primary : C.textLt, flexShrink: 0 }}>
                  {p.turno || '?'}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <div style={{ fontSize: 15, fontWeight: 700, color: C.text }}>
                      {p.usuario_id === participante.usuario_id ? (p.usuarios?.nombre?.split(' ')[0] || 'Tú') + ' (Tú)' : `Cliente #${p.usuarios?.codigo_ref || '—'}`}
                    </div>
                    <NivelBadge nivel={p.usuarios?.nivel || 'Bronce'} />
                  </div>
                  <div style={{ fontSize: 13, color: C.textLt, marginTop: 2 }}>
                    {p.turno ? `Cobra en semana ${p.turno}` : 'Turno por sortear'}
                  </div>
                </div>
                {p.turno === tanda?.semana_actual && (
                  <span style={{ background: C.successLt, color: C.success, fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 99 }}>Cobra esta semana</span>
                )}
              </div>
            ))
          )}
        </Card>

      </div>
    </div>
  );
}

export { DetalleTanda };
